import React, { Component } from 'react';
import MenuItemSeattle from './MenuItemSeattle';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import MenuBubbleSeattle from './MenuBubbleSeattle';
import ListMenuSeattle from './ListMenuSeattle';
import { getRandomStr } from '../../../utils/shared';
import _ from 'lodash';

const MAX_MENU_ELEMENTS = 7;

class MenuSeattle extends Component {
  constructor(props) {
    super(props);

    this._nonActiveItemDiameterPercentage = 13.75;
    this._activeInnerItemDiameterPercentage = 17.45;
    this._activeOuterItemDiameterPercentage = 19.45;
    this._activeShadowItemDiameterPercentage = 21.21;
    this._items = this.props.items;
    this._menuItemsRefs = []
    this._mainElement = null;
    this._currentElementId = null;
    this._itemsRefs = [];
    this._originalCoordinatesElements = [];
    this._allElements = [];
    this._itemsRefsSet = false;
    this._bubblesAnimated = false;
    this._secondSetupHasNotRunYet = true;
    this._distanceFromOriginalPosition = [];
    this._distancesFromMain = [];
    this._menuBubbleTranslationMap = {};

    this.state = {
      mainElement: null,
      menuActive: this.props.menuActive,
      activeBubbleId: null,
      listMenuActive: false,
      mainElementId: null,
      items: [],
      subItems: [],
    }
  }

  componentDidMount() {
    for (let i = 0; i < this._items.length; i++) {
      this._items[i].rank = i;
    }
    this.setupItemsCoordinates(this.props.menuActive);
    this.renderElements(this._allElements);
    if (this.props.activateBubble !== undefined) {
      let mainElement = _.find(this.props.items, { active: true });
      if (mainElement) {
        this.menuElementTouch(mainElement.id);
      }
    }

    // this.loopTestAnimateMenu();
  }

  componentWillUnmount() {
    // console.log("Menu Seattle Will Unmount");
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.menuActive && (prevState.mainElementId !== this.state.mainElementId)) {
      let mainElement = _.find(this.props.items, { id: this.state.mainElementId });
      if (this.state.subItems.length === 0) {
        if (mainElement.children && mainElement.children.length > 0) {
          this.setState({
            subItems: mainElement.children,
            bubblePrimaryColor: _.get(mainElement.contents, 'custom_fields.sub_menu_primary.val', null),
            bubbleSecondaryColor: _.get(mainElement.contents, 'custom_fields.sub_menu_secondary.val', null)
          });
        }
      }
    } else {
      if (!this.state.menuActive && (prevState.mainElementId === this.state.mainElementId)) {
        // this.animateBubbles(this._allElements);
      }
    }
  }

  loopTestAnimateMenu = () => {
    this._timeoutAnimateMenu = setTimeout(() => {
      let id;
      let randomIndex;
      do {
        randomIndex = Math.floor(Math.random() * (this._items.length - 1));
        id = _.get(this._items, '['+randomIndex+'].id', null)
      } while(this._currentElementId === id || id === null)
      this.menuElementTouch(id);
      this.loopTestAnimateMenu();
    }, 4000);
  }

  animateBubbles = (elementsWCoordinates) => {
    for (let i = 0; i < elementsWCoordinates.length; i++) {
      let x = elementsWCoordinates[i].coordinates.x;
      let y = elementsWCoordinates[i].coordinates.y;
      
      this._itemsRefs[i].el.animate([
        {
          transform: "translate(0px, 0px)"
        },
        {
          transform: `translate(${x}px, ${y}px)`
        }
      ], {
        fill: "forwards",
        duration: 500
      });
    }

    this._bubblesAnimated = true;
  }

  animateBubblesActive = (prevElementId, newElementId) => {
    if (prevElementId !== undefined && prevElementId !== null && newElementId !== undefined && newElementId !== null) {
      let prevElementRef = _.filter(this._itemsRefs, { data: { id: prevElementId } });
      let newElementRef = _.filter(this._itemsRefs, { data: { id: newElementId } });

      this._menuBubbleTranslationMap[prevElementId] = Object.assign({}, this._menuBubbleTranslationMap[newElementId]);
      prevElementRef = prevElementRef[0];
      newElementRef = newElementRef[0];

      let movePrevX = -(this._menuBubbleTranslationMap[newElementId].distanceX);
      let movePrevY = -(this._menuBubbleTranslationMap[newElementId].distanceY);

      prevElementRef.el.animate([
        {
          transform: "translate(0px, 0px)"
        },
        {
          transform: `translate(${movePrevX}px, ${movePrevY}px)`
        }
      ], {
        fill: "forwards",
        duration: 500
      });
  
      let moveNewX = this._menuBubbleTranslationMap[newElementId].distanceX;
      let moveNewY = this._menuBubbleTranslationMap[newElementId].distanceY;
      newElementRef.el.animate([
        {
          transform: "translate(0px, 0px)"
        },
        {
          transform: `translate(${moveNewX}px, ${moveNewY}px)`
        }
      ], {
        fill: "forwards",
        duration: 500
      });
      let newElementMenuRef = _.find(this._menuItemsRefs, (ref) => {
        return ref.data.id === newElementId;
      });
      newElementMenuRef.el.activate();
      _.forEach(this._itemsRefs, (ref, i) => {
        if (ref.data.id === newElementId) {
          ref.el.style.zIndex = 9999;
        } else {
          ref.el.style.zIndex = i;
        }
      });
      
      setTimeout(() => {
        this.reOrganizeElements(newElementId, prevElementId);
        this.renderElements(this._allElements, true);
      }, 700)
    }
  }

  reOrganizeElements = (newElementId, prevElementId) => {
    let coordinatesForNewElement = {}
    let coordinatesForPrevElement = {}
    let newIndex;
    let prevIndex;
    for (let i = 0; i < this._allElements.length; i++) {
      if (this._allElements[i].id === newElementId) {
        this._allElements[i] = Object.assign({}, this._allElements[i]);
        this._allElements[i].active = true;
        this._allElements[i].main = true;
        newIndex = i;
        coordinatesForPrevElement = Object.assign({}, this._allElements[i].coordinates);
      } else {
        this._allElements[i] = Object.assign({}, this._allElements[i]);
        if (this._allElements[i].id === prevElementId) {
          prevIndex = i;
          coordinatesForNewElement = Object.assign({}, this._allElements[i].coordinates);
        }
        this._allElements[i].active = false;
        this._allElements[i].main = false;
      }
    }

    this._allElements[newIndex].coordinates = coordinatesForNewElement;
    this._allElements[prevIndex].coordinates = coordinatesForPrevElement;
  }

  handleItemClick = (id, elementKey) => {
    if (elementKey !== undefined && elementKey !== null) {
      this.menuElementTouch(id);
    }
  }

  handleBubbleClick = (parentId, bubbleItemId) => {
    let item = _.find(this._items, { id: parentId });
    let bubbleItem = _.find(item.children, { id: bubbleItemId });
    let showMenu = false;
    if (bubbleItem.children && bubbleItem.children.length > 0){
      if (bubbleItem.children[0].folder_module) {
        this.props.changeContent(parentId, bubbleItemId);
      }
      else { //navigation
        this.props.changeContent(parentId, bubbleItemId, 0, 0);
        showMenu = true;
      }
    }
    
    // console.log(JSON.stringify(bubbleItem));
    if (showMenu) {
      this.setState({
        listMenuActive: true,
        listMenuItems: bubbleItem.children,
        listMenuParentId: bubbleItem.id,
        listMenuItemBackground: _.get(item.contents, 'custom_fields.secondary_color.val', null),
        listMenuSelectedBackground: _.get(this._mainElement.contents, 'custom_fields.list_menu_selected_background.val', null),
        listSubMenuSelectedBackground: _.get(this._mainElement.contents, 'custom_fields.list_submenu_selected_background.val', null)
      });
    } else {
      this.setState({
        listMenuActive: false,
      });
    }
  }

  handleListItemClick = (bubbleId, parentListItemId, childListItemId) => {
    this.props.changeContent(this.state.mainElementId, bubbleId, parentListItemId, childListItemId);
  }

  menuElementTouch = (id) => {
    let subItems = [];
    // let elementsWCoordinates = this.setupItemsCoordinates(true, id);
    let activeBubbleId = null;
    let activeListItemId = null;
    let activeChildListItemId = null;

    // this._allElements = elementsWCoordinates;
    if (!this.state.menuActive) {
      this.setupItemsCoordinates(true, id);
      this.animateBubbles(this._allElements);
      _.forEach(this._menuItemsRefs, ref => {
        if (ref.data.id === id) {
          ref.el.activate();
        }
      });

      _.forEach(this._itemsRefs, (ref, i) => {
        if (ref.data.id === id) {
          ref.el.style.zIndex = 9999;
        } else {
          ref.el.style.zIndex = i;
        }
      });
    } else {
      if (this._secondSetupHasNotRunYet) {
        this.setupItemsCoordinates(true, this._currentElementId, true);
        this._secondSetupHasNotRunYet = false;
      }
      
      if (this._currentElementId === null) {
        this.renderElements(this._allElements, true);
      } else {
        this.renderElements(this._allElements);
      }
      this.animateBubblesActive(this._currentElementId, id);
    }
    
    this._currentElementId = id;
    this._mainElement = _.find(this._allElements, { id: id });

    this.props.storeMenuStatus(true, id);
    if (this._mainElement.children && this._mainElement.children.length > 0) {
      if (this._mainElement.children[0].folder_module) {
        this.props.changeContent(id, null, null, null);
      } else {
        subItems = _.orderBy(this._mainElement.children, ['rank'], ['asc']);
        
        if (subItems && subItems.length > 0) {
          if (!subItems[0].folder_module) {
            activeListItemId = 0;
            if (subItems[0].children && subItems[0].children.length > 0) {
              if (!subItems[0].children[0].folder_module) {
                activeChildListItemId = 0;
              }
            }
          }
        }

        activeBubbleId = subItems && subItems.length > 0 ? subItems[0].id : null;
        setTimeout(() => {
          this.handleBubbleClick(id, subItems[0].id);
          setTimeout(() => {
            this.handleListItemClick(subItems[0].id, activeListItemId, activeChildListItemId);
          }, 250);
        }, 500);
      }
    }
    
    this.setState({
      menuActive: true,
      mainElementId: id,
      activeBubbleId: activeBubbleId,
      bubblePrimaryColor: _.get(this._mainElement.contents, 'custom_fields.sub_menu_primary.val', null),
      bubbleSecondaryColor: _.get(this._mainElement.contents, 'custom_fields.sub_menu_secondary.val', null),
      subItems: subItems,
      listMenuActive: false
    });
  }

  setupItemsCoordinates = (active, activeElement, secondRender) => {
    let elementsAround = [];
    let mainElement = {};
    let mainElementOriginalIndex = null;

    if (activeElement === undefined || activeElement === null) {
      this._mainElementIndex = _.findIndex(this._items, { main: true });
      mainElement = this._items[this._mainElementIndex];
      mainElementOriginalIndex = this._mainElementIndex;
      // this._currentElementId = mainElement.id;
    } else {
      for (let i = 0; i < this._items.length; i++) {
        if (this._items[i].id === activeElement) {
          this._items[i].main = true;
          this._items[i].active = true;
          mainElement = Object.assign({}, this._items[i]);
          mainElementOriginalIndex = i;
          // this._currentElementId = mainElement.id;
        } else {
          this._items[i].main = false;
          this._items[i].active = false;
        }
      }
    }
    
    for (let j = 0; j < this._items.length; j++) {
      if (!this._items[j].main) {
        elementsAround.push({
          element: this._items[j],
          originalIndex: j
        });
      }
    }

    let itemRadius = this._nonActiveItemDiameterPercentage / 100 * this.props.regionWidth;
    if (active) {
      itemRadius *= 1.18;
    }

    if (active && !secondRender) {
      if (this._originalCoordinatesElements.length > 0) {
        mainElement.coordinates = {
          x: this.props.mainItemCoordinates.x - this._originalCoordinatesElements[mainElementOriginalIndex].coordinates.x,
          y: this.props.mainItemCoordinates.y - this._originalCoordinatesElements[mainElementOriginalIndex].coordinates.y
        }
      } else {
        mainElement.coordinates = {
          x: this.props.mainItemCoordinates.x,
          y: this.props.mainItemCoordinates.y
        }  
      }
    } else {
      mainElement.coordinates = {
        x: this.props.mainItemCoordinates.x,
        y: this.props.mainItemCoordinates.y
      }
    }
    
    let offset = Math.PI / 2;
    let theta = Math.PI * 2 / (MAX_MENU_ELEMENTS - 1);

    if (active) {
      theta = Math.PI * 2 / (MAX_MENU_ELEMENTS + 1);
      offset = (Math.PI / 2) + theta;
    }

    let allElements = [];
    let elementsWithTranslateDistances = [];
    for (let i = 0; i < elementsAround.length; i++) {
      let element = elementsAround[i].element;
      let elementWithDistance = elementsAround[i].element;
      let index = elementsAround[i].originalIndex;
      let angle = theta * i;

      let x = 0;
      let y = 0;
      
      let newOriginalPosX = 0;
      let newOriginalPosY = 0;
      if (active && !secondRender) {
        if (this._originalCoordinatesElements.length > 0) {
          newOriginalPosX = (itemRadius * 0.85 * Math.cos(angle + offset)) + this.props.mainItemCoordinates.x;
          newOriginalPosY = this.props.mainItemCoordinates.y - (itemRadius * 0.85 * Math.sin(angle + offset));
          x = -(this._originalCoordinatesElements[index].coordinates.x - newOriginalPosX);
          y = -(this._originalCoordinatesElements[index].coordinates.y - newOriginalPosY);
  
          this._menuBubbleTranslationMap[element.id] = {
            distanceX: this.props.mainItemCoordinates.x - newOriginalPosX,
            distanceY: this.props.mainItemCoordinates.y - newOriginalPosY
          }
        } else {
          x = (itemRadius * 0.85 * Math.cos(angle + offset)) + this.props.mainItemCoordinates.x;
          y = this.props.mainItemCoordinates.y - (itemRadius * 0.85 * Math.sin(angle + offset));
        }
      } else {
        x = (itemRadius * 0.85 * Math.cos(angle + offset)) + this.props.mainItemCoordinates.x;
        y = this.props.mainItemCoordinates.y - (itemRadius * 0.85 * Math.sin(angle + offset));

        this._menuBubbleTranslationMap[element.id] = {
          distanceX: this.props.mainItemCoordinates.x - x,
          distanceY: this.props.mainItemCoordinates.y - y
        }
      }      
  
      element.coordinates = {
        x: x,
        y: y
      }

      elementWithDistance.coordinates = {
        x: x,
        y: y
      }
      allElements.push(element);
      elementsWithTranslateDistances.push(elementWithDistance);
    }

    allElements.push(mainElement);
    elementsWithTranslateDistances.push(mainElement);
    allElements = _.sortBy(allElements, ['rank']);
    this._allElements = allElements;
    if (this._originalCoordinatesElements.length === 0) {
      this._originalCoordinatesElements = _.cloneDeep(allElements);
    }

    this._mainElement = mainElement;
    return elementsWithTranslateDistances;
  }

  renderElements = (elementsCoordinates, active) => {
    let renderedElements = [];
    let mainElementIndex = null;
    let randomKey = getRandomStr();
    for (let i = 0; i < elementsCoordinates.length; i++) {
      if (elementsCoordinates[i].main) {
        mainElementIndex = i;
        continue;
      }

      let x = elementsCoordinates[i].coordinates.x;
      let y = elementsCoordinates[i].coordinates.y;
      let renderedElement = (
        <div key={randomKey + i} style={{ position:"absolute", left: x, top: y }} ref={el => this._itemsRefs[i] = { el: el, data: { id: elementsCoordinates[i].id } }} >
          <MenuItemSeattle
            id={i}
            ref={el => this._menuItemsRefs[i] = { el: el, data: { id: elementsCoordinates[i].id } }}
            elementId={elementsCoordinates[i].id}
            width={this.props.regionWidth}
            height={this.props.regionHeight}
            active={elementsCoordinates[i].active}
            main={elementsCoordinates[i].main}
            left={0}
            top={0}
            color={elementsCoordinates[i].contents.custom_fields.background_color.val}
            secondaryColor={elementsCoordinates[i].contents.custom_fields.secondary_color.val}
            handleClick={this.handleItemClick}
            setActive={this.setItemActive}
            nonActiveItemDiameterPercentage={this._nonActiveItemDiameterPercentage}
            activeInnerItemDiameterPercentage={this._activeInnerItemDiameterPercentage}
            activeOuterItemDiameterPercentage={this._activeOuterItemDiameterPercentage}
            activeShadowItemDiameterPercentage={this._activeShadowItemDiameterPercentage}
          >
            {elementsCoordinates[i].name}
          </MenuItemSeattle>
        </div>
      );
      renderedElements.push(renderedElement);
    }

    let x = elementsCoordinates[mainElementIndex].coordinates.x;
    let y = elementsCoordinates[mainElementIndex].coordinates.y;
    let mainElement = (
      <div key={randomKey + mainElementIndex} style={{ position:"absolute", left: x, top: y }} ref={el => this._itemsRefs[mainElementIndex] = { el: el, data: { id: elementsCoordinates[mainElementIndex].id } }} >
        <MenuItemSeattle
          id={mainElementIndex}
          ref={el => this._menuItemsRefs[mainElementIndex] = { el: el, data: { id: elementsCoordinates[mainElementIndex].id } }}
          elementId={elementsCoordinates[mainElementIndex].id}
          width={this.props.regionWidth}
          height={this.props.regionHeight}
          left={0}
          top={0}
          color={elementsCoordinates[mainElementIndex].contents.custom_fields.background_color.val}
          main={true}
          active={active}
          secondaryColor={elementsCoordinates[mainElementIndex].contents.custom_fields.secondary_color.val}
          handleClick={this.handleItemClick}
          setActive={this.setItemActive}
          nonActiveItemDiameterPercentage={this._nonActiveItemDiameterPercentage}
          activeInnerItemDiameterPercentage={this._activeInnerItemDiameterPercentage}
          activeOuterItemDiameterPercentage={this._activeOuterItemDiameterPercentage}
          activeShadowItemDiameterPercentage={this._activeShadowItemDiameterPercentage}
        >
          {elementsCoordinates[mainElementIndex].name}
        </MenuItemSeattle>
      </div>
    );
    renderedElements.push(mainElement);

    this.setState({
      items: renderedElements,
      mainElementId: this._mainElement.id
    });
  }

  render() {
    return (
      <div>
        <div style={{ position: "absolute", top: this.props.screenY, left: this.props.screenX }}>
          {this.state.items}
        </div>
        <div style={{ position: "absolute", top: this.props.contentY, left: this.props.contentX }}>
          <CSSTransitionGroup
            component='div'
            className="fastfadedelay"
            style={{ minHeight: '100%' }}
            transitionName='example'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.menuActive}>
              {
                this.state.menuActive ?
                <MenuBubbleSeattle
                  itemId={this.state.mainElementId}
                  items={this.state.subItems}
                  screen={this.props.screen}
                  regionWidth={this.props.regionWidth}
                  regionHeight={this.props.regionHeight}
                  contentY={this.props.contentY}
                  regionX={this.props.regionX}
                  regionY={this.props.regionY}
                  click={this.handleBubbleClick}
                  bubbleId={this.state.activeBubbleId}
                  primaryColor={this.state.bubblePrimaryColor}
                  secondaryColor={this.state.bubbleSecondaryColor}
                />
                :null
              }
            </div>

          </CSSTransitionGroup>
          <CSSTransitionGroup
            component='div'
            className="fastfadedelay"
            style={{ minHeight: '100%' }}
            transitionName='example'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
              <div key={this.state.listMenuActive} style={{ width: 0.13185 * this.props.regionWidth, position:"absolute", left: 0.433125 * this.props.regionWidth, top:0.185625 * this.props.regionWidth }}>
              {
                this.state.listMenuActive ? 
                <ListMenuSeattle
                  regionWidth={this.props.regionWidth}
                  parentId={this.state.listMenuParentId}
                  items={this.state.listMenuItems}
                  screen={this.props.screen}
                  color={this.state.listMenuItemBackground}
                  listMenuSelectedBackground={this.state.listMenuSelectedBackground}
                  listSubMenuSelectedBackground={this.state.listSubMenuSelectedBackground}
                  click={this.handleListItemClick}
                />
                : null
              }
              </div>
            </CSSTransitionGroup>
        </div>
      </div>
    )
  }
}

export default MenuSeattle;


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/MenuSeattle.jsx